export default {
  getCurrencies(state) {
    return state.currencies;
  },
  getExchangeRates(state) {
    return state.exchange_rates;
  },
};
